import { Box } from "@mui/material";
//import VerizonPrimaryLogo from "../assets/Verizon-primary.svg"
import Grouplogo from "../assets/Group.svg"

export function LegalDisclaimer() {
  const normalQStyle = {
    container: {
      marginTop: '24px',
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "64px",
      backgroundColor: "#fff",
      borderRadius: '12px',
      lineHeight: '16px',
      padding: "14px 20px"
    },
    imageAndTextContainer: {
      display: "flex",
      position: "relative",
      justifyContent: "center",
      alignItems: "center",
      padding: "5px 5px"
    },
    image: {
      width: "150px",
      height: "38px",
    },
    text: { margin: "0px 20px", fontSize: "16px" },
    textBold: { fontSize: "16px", fontFamily: 'VerizonNHGDSBold', fontWeight: "bolder" },
  };

  return (
    <div style={normalQStyle.container}>
      <Box
        width={"auto"}
        height={"auto"}
        sx={normalQStyle.imageAndTextContainer}
      >
        <img
            alt="profile-user"
            width="150px"
            height="38px"
            src={Grouplogo}
          />
        <p style={normalQStyle.text}>
          {/* <span style={normalQStyle.textBold}>Content is included for discussion purposes only :</span> */}
          {/* &nbsp;  */}
          © 2025 Verizon. All Rights Reserved
        </p>
      </Box>
    </div>
  );
}
